import FilterItem from "./FilterItem.vue";
import CurrencyFilterBody from "./bodies/CurrencyFilterBody.vue";
import { truncateString } from "@/utils";
export default {
  name: "CurrencyFilter",
  components: {
    FilterItem,
    CurrencyFilterBody
  },
  emits: ["apply", "cleared"],
  props: {
    currencies: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    },
    onlyMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getCurrencyTitle() {
      let joinedCurrencies = this.currencies.selected?.map(({
        currency
      }) => currency).join(', ');
      joinedCurrencies = joinedCurrencies ? truncateString(joinedCurrencies, 20) : 'Currency';
      return joinedCurrencies;
    },
    getCurrencySelectedTitle() {
      const joined = this.currencies.selected?.map(({
        symbol
      }) => symbol).join(', ');
      return joined ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    onClear() {
      this.currencies.clear();
      this.$emit('cleared');
    },
    onRestoreSearch() {
      this.currencies.restoreSearch();
    },
    onSelect({
      symbol
    }) {
      if (this.onlyMode) {
        this.currencies.selectOnly({
          symbol
        }, 'symbol');
      } else {
        this.currencies.select({
          symbol
        }, 'symbol');
      }
    },
    onSelectOnly({
      symbol
    }) {
      this.currencies.selectOnly({
        symbol
      }, 'symbol');
    },
    onDeSelect({
      symbol
    }) {
      this.currencies.deselect({
        symbol
      }, 'symbol');
      if (this.currencies?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    onSearch({
      value
    }) {
      this.currencies.listSearch(value, ['currency', 'country', 'region']);
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.currencies.clearDraft();
    },
    onHidden() {
      this.currencies.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    onClose() {
      this.$refs?.currencyFilterItem?.closeDropdown();
    }
  }
};